import type { TranslationKey } from "./translator";

export const SIGN_IN_INVITATIONS = [
  "login.passwordFlow.invitations.today",
  "login.passwordFlow.invitations.minutes",
  "login.passwordFlow.invitations.startsHere",
  "login.passwordFlow.invitations.closer",
  "login.passwordFlow.invitations.pickUp",
] as const satisfies readonly TranslationKey[];

export const SIGN_IN_INVITATION_MS = 4000;

export function firstSignInInvitation(random: () => number = Math.random): number {
  return Math.floor(random() * SIGN_IN_INVITATIONS.length) % SIGN_IN_INVITATIONS.length;
}

export function nextSignInInvitation(index: number): number {
  return (index + 1) % SIGN_IN_INVITATIONS.length;
}
